define('BookingEngine/app-General/dialog',['../../app/ui/dialog'], function (dialog) {
    return {
        showDialog: function (dialogContent) {
            var currentWidth = $(window).width();
            var currentHeight = $(window).height();
            var dialogProportion = 0.8;
            var dialogWidth = Math.floor(currentWidth * dialogProportion);
            var dialogHeight = Math.floor(currentHeight * dialogProportion);

            var template = $('#myDialogContent').clone();       

            var open = function (id) {
                template.load(dialogContent);

                $('#' + id).find('.modal-content')
                    .append('<div class="ui-dialog-buttonset" ><button type="button" class="closeItinBtn ui-button ui-corner-all ui-widget" data-dismiss="modal">Close</button><button type="button" class="printItinBtn ui-button ui-corner-all ui-widget">Print</button></div>')

                $('.printItinBtn').click(printPage);

                
            };

            var modal = dialog.show('', template, { onOpen: open, height: dialogHeight, width: dialogWidth }, false, ['modal-closable']); 

            $(window).resize(function () {
                var currentWidth = $(window).width();
                var currentHeight = $(window).height();
                var dialogProportion = 0.8;
                var dialogWidth = Math.floor(currentWidth * dialogProportion);
                var dialogHeight = Math.floor(currentHeight * dialogProportion);

                modal.adjustSize(dialogWidth, dialogHeight);
            });

            //Remove the ui state from the buttons on the dialog.
            $('.printItinBtn').removeClass('ui-state-default');
            $('.closeItinBtn').removeClass('ui-state-default');

            function printPage() {
                var openNewWindow = window.open();
                var divToPrint = template.html();

                openNewWindow.document.write(divToPrint);
                openNewWindow.window.print();
                openNewWindow.document.close();

                //To close the new blank page that opens.
                setTimeout(function() {
                    openNewWindow.close();
                }, 10);
            };
        }
    };
});
